import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, FileText, Building2, Search, Package } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { services } from '../data/mockData';

const iconMap = { Shield, FileText, Building: Building2, Search, Package };

const servicesSlugs = [
  'trademark-registration', 'copyright-registration', 'company-formation',
  'trademark-search', 'amazon-brand-registry'
];

const OurServicesSection = () => {
  const navigate = useNavigate();

  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">What We Do</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-5">
            Intellectual Property Services Built for Growth
          </h2>
          <p className="text-base text-[#4B5563] leading-relaxed">
            From trademark filing to Amazon Brand Registry enrollment, we provide the legal foundation your business needs to scale confidently.
          </p>
        </div>

        <div className="space-y-0 border border-[#E5E7EB]">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon] || Shield;
            return (
              <div
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className={`group flex flex-col md:flex-row items-stretch transition-all duration-500 hover:bg-[#F8F9FA] ${index !== services.length - 1 ? 'border-b border-[#E5E7EB]' : ''}`}
              >
                {/* Number + Icon */}
                <div className="w-full md:w-20 flex md:flex-col items-center justify-center gap-3 md:gap-2 p-4 md:p-6 md:border-r border-[#E5E7EB] bg-[#F8F9FA] group-hover:bg-[#002FA7] transition-colors duration-500">
                  <span className="text-xs font-bold text-[#4B5563] group-hover:text-white/60 transition-colors">0{service.id}</span>
                  <Icon className="w-5 h-5 text-[#002FA7] group-hover:text-white transition-colors duration-500" />
                </div>

                {/* Content */}
                <div className="flex-1 p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-[#0A0F1C] group-hover:text-[#002FA7] transition-colors duration-300 mb-2">
                      {service.title}
                    </h3>
                    <p className="text-sm text-[#4B5563] leading-relaxed max-w-xl">{service.description}</p>
                  </div>
                  <Button
                    data-testid={`service-cta-${service.id}`}
                    onClick={() => navigate(`/services/${servicesSlugs[index]}`)}
                    variant="outline"
                    className="rounded-none border-[#E5E7EB] text-[#0A0F1C] font-medium text-sm px-6 h-10 transition-all duration-300 hover:border-[#002FA7] hover:text-[#002FA7] hover:bg-[#002FA7]/5 hover:-translate-y-0.5 flex-shrink-0 self-start md:self-center"
                  >
                    Learn More <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurServicesSection;
